exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._30AJrJ2J1d5FOBBezHBBKb{height:100%;width:420px;flex-shrink:0}@media(max-width: 768px){._30AJrJ2J1d5FOBBezHBBKb{width:100%;height:calc(100vh - 155px)}}._30AJrJ2J1d5FOBBezHBBKb h2{font-size:20px !important;font-weight:600 !important}", ""]);

// Exports
exports.locals = {
	"chatContainer": "_30AJrJ2J1d5FOBBezHBBKb"
};